export default {
  LOAD_CYCLE_SKILL_ABILITY_FORM_PAGE_START: 'LoadCycleSkillAbilityFormPageStart',
  LOAD_CYCLE_SKILL_ABILITY_FORM_PAGE_END: 'LoadCycleSkillAbilityFormPageEnd',
  LOAD_CYCLE_SKILL_ABILITY_AVAILABLE_SKILL_ABILITIES_START: 'LoadCycleSkillAbilityAvailableSkillAbilitiesStart',
  LOAD_CYCLE_SKILL_ABILITY_AVAILABLE_SKILL_ABILITIES_END: 'LoadCycleSkillAbilityAvailableSkillAbilitiesEnd'
};